import { useMemo, useRef, useState } from 'react';
import { ReactSimpleComponentProps } from '@/custom-types';
import { AddBudgetFormModalContext, AddBudgetFormModalContextProps } from './AddBudgetFormModalContext';
import { CreateBudgetInput } from '@/graphql/generated';

export const AddBudgetFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const budgetDataRef = useRef<CreateBudgetInput | null>(null)
  const [isOpen, setOpen] = useState(false)

  const actions = useMemo<Omit<AddBudgetFormModalContextProps, 'budgetData' | 'isOpen'>>(() => ({
    closeModal: () => {
      setOpen(false)
      budgetDataRef.current = null
    },

    openModal: (budgetData?: CreateBudgetInput) => {
      setOpen(true)

      if (budgetData) budgetDataRef.current = budgetData
    },
  }), [])

  return (
    <AddBudgetFormModalContext.Provider value={{ ...actions, isOpen, budgetData: budgetDataRef.current}}>
      {children}
    </AddBudgetFormModalContext.Provider>
  )
}